// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-button.exit-room-button ion-icon {\n  transform: rotate(135deg);\n  color: var(--ion-toolbar-background);\n}", "",{"version":3,"sources":["webpack://./src/components/ExitButton/styles.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,oCAAA;AAAJ","sourcesContent":["ion-button.exit-room-button {\n  ion-icon {\n    transform: rotate(135deg);\n    color: var(--ion-toolbar-background);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
